// extracted by mini-css-extract-plugin
export default {"tag":"TypeTag_tag__nkWPw","wire":"TypeTag_wire__vgs+y","ach":"TypeTag_ach__-W6su","card":"TypeTag_card__0hS1W","check":"TypeTag_check__eAPLB","cashback":"TypeTag_cashback__N2lni"};